import React from "react";
import CardSimple from "../../../../components/basic/CardSimple";

const Product = () => {
  return (
    <div id="add-product-category">
      <br />
      <div>
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Add a Product Category</h2>
            <ul>
              <li>Go to Menu > Inventory > Categories</li>
              <img
                src={require("./SupportDocImages/product_images/product.PNG")}
              />
              <li>Click on 'Add New Category' in the toolbox</li>
              <img src="http://techpos.ca/support-images/Products/Category/Category-2.png" />
              <li>Fill out the information</li>
              <img
                src="http://techpos.ca/support-images/Products/Category/Category-3.png"
                width="800"
              />
              <li>Click on Save</li>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="add-products">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Add Products</h2>
            <p>
              NOTE: It is necessary to have a Product Category, Price Matrix and
              Measurement Settings created before crating a Product.
            </p>
            <ul>
              <li>Go to Menu > Inventory > Products</li>
              <img
                src={require("./SupportDocImages/product_images/product.PNG")}
              />
              <li>Click on 'Add New Product' in the toolbox</li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-2.png" />
              <li>
                Fill out the name, type and category. By default, the product is
                active -- you can change it by toggling the button.
              </li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-3.png" />
            </ul>
            <hr />
            <h3 style={{ color: "#000" }}>Adding Unit Products</h3>
            <ul>
              <li>Under type, select unit</li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-4.png" />
              <li>Select the category</li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-5.png" />
              <li>Add the price</li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-6.png" />
              <p>
                <b>NOTE:</b> The required fields are Name, Type, Category and
                Price. If you don't determine a SKU for the product, the system
                will autogenerate one for you.
              </p>
            </ul>
            <hr />
            <h3 style={{ color: "#000" }}>Adding Bulk Products</h3>
            <p>
              <b>NOTE:</b> A Price Matrix is required for Bulk items. For
              instructions on how to create one, please take a look at the
              section 'How to Add a Price Matrix'.
            </p>
            <ul>
              <li>Under type, select Bulk</li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-7.png" />
              <li>Select the category</li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-8.png" />
              <li>Under Price Info, Select the Price Matrix</li>
              <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-9.png" />
              <li>Click on Save</li>
              <p>
                <b>NOTE:</b> The column 'Campaign Active' cannot be edited from
                this screen. If you want a Measurement Setting to be a part of
                the campaign, you can edit it from the section Price Matrix. For
                instructions on how to edit Price Matrices, please refer to the
                section 'How to Edit a Price Matrix?'.
              </p>
            </ul>
          </div>
          <hr />
          <div id="add-prepack-product">


            <div className="support-wrapper support-manual">
              <h2>Add a Pre-Pack Product</h2>
              <ul>
                <li>Under Type, Select Pre-Pack</li>
                <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-10.png" />
                <li>Select the Category</li>
                <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-8.png" />
                <li>
                  Type how much weight is in one unit (<b>NOTE:</b> If you don't
                  fill this out properly, you will get an error during the sales
                  transaction)
                </li>
                <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-11.png" />
                <li>Select the Price Matrix and click on Save</li>
                <img src="http://techpos.ca/support-images/Products/CreateProd/Prod-9.png" />
              </ul>
            </div>
          </div>
        </CardSimple>
      </div>
    </div>
  );
};

export default Product;
